const riot = require('riot');

riot.tag2('module-thanks-point_at_gift', '<div class="bg-grad_light_blue w-full h180 pt24"> <div class="text-center ts-hl text-white">ありがとうございました</div> </div> <div class="px24 mtn105"> <div class="w-full p20 rounded-8 elevation-default-mid text-center bg-white mb24"> <div class="f fh mb16"><img class="block s105 object-fit-contain" riot-src="/images/{opts.event.point_provider}/logo.svg"></div> <div class="ts-hs text-gray_80 mb4">ポイント＠ギフト（dポイント）</div> <div class="f fc fb"> <div class="fs40 text-gray_80 mr8">{opts.event.amount.toLocaleString()}</div> <div class="ts-hs text-gray_60">ポイント</div> </div> </div> <div class="border-bottom border-bottom pb24 mb24"> <div class="ts-ps text-gray_80 mb24">下に記載しているURLからポイント＠ギフト（dポイント）をお受け取りください。</div> <div class="ts-ps text-gray_80">このページは {dayjs(opts.event.expires_at).format(\'YYYY年M月D日 HH時mm分\')} 以降は閲覧できなくなります。</div> </div> <div class="mb24"> <div class="text-gray_80 ts-pxs" data-is="atom-anchorify" text="{description}"></div> </div> <div class="mb24"> <div class="text-gray_60 ts-pxs" data-is="atom-anchorify" text="{message}"></div> </div> </div>', '', '', function(opts) {
    const event = this.opts.event;

    var description = `この度は、${event.campaign_display_name}にご応募いただき、誠にありがとうございます。
      ${event.campaign_display_company_name} ${event.campaign_display_name}運営事務局でございます。
      ポイント＠ギフト（dポイント）を進呈いたします。

      ●ポイント＠ギフト（dポイント）情報
      　・ポイント＠ギフト（dポイント） : ${event.ntt_card_solutions_distribution.gift_id}
      　・ポイント数 : ${event.amount.toLocaleString()}ポイント
      　・管理番号 : ${event.ntt_card_solutions_distribution.gift_manage_id}
      　・有効期限 : ${dayjs(event.ntt_card_solutions_distribution.expires_at).format('YYYY/MM/DD')}
      　・ギフトID付登録URL : ${event.ntt_card_solutions_distribution.distribution_url}

      ●ポイント＠ギフト（dポイント）とは（発行元：株式会社NTTカードソリューション）
      ポイント＠ギフト（dポイント）は、dポイントクラブ会員番号にdポイントを加算できるサービスです。
      https://atgift.jp/user/item/dpoint/

      ●dポイントクラブとは
      　ドコモのケータイ回線をお持ちでない方も含め、どなたでもご入会いただけるポイントプログラムです。
      　たまったポイントはドコモ商品の購入や他社ポイントなどの交換に加え、dポイント加盟店でのお買物や月々の携帯電話ご利用料金にも利用できます。
      　dポイント詳細はこちら（ https://dpoint.jp/index.html ）をご覧ください。

      ●ポイント＠ギフト（dポイント）のご利用方法
      　下記URLにて利用手順をご確認のうえ、ご利用ください。
      https://atgift.jp/user/item/dpoint/?sid=section4
      　1．dポイントの加算登録をおこないます。
      　「有効期限」内に、下記登録サイトまたは「ギフトID付登録URL」にアクセスし、ポイント＠ギフト（dポイント）の加算登録をおこなってください。
      　（「ギフトID付登録URL」にアクセスすると、IDが自動入力されます。）
      　登録サイト ： https://ejoica.jp/dpoint/
      　※dポイントの加算登録には、dアカウントの作成およびdポイントクラブへの入会が必要です。
      　※dアカウントの作成およびdポイントクラブへの入会がお済みでない方は、登録サイトから手続きをお願いいたします。

      　2．dポイントが加算登録されます。
      　※登録サイト「STEP2 内容確認」画面に表示されるdポイントクラブ会員番号が、ポイント加算対象となります。　
      　※dポイント加算登録後のキャンセルはできません。
      　※dポイントは加算登録後即時加算されます。

      ●ポイント＠ギフト（dポイント）のご注意事項
      　・ポイント＠ギフト（dポイント）には有効期限があります。有効期限を過ぎるとご利用できなくなります。
      　・ポイント＠ギフト（dポイント）の登録キャンセル・換金・返金・再発行等はできません。
      　・ポイント＠ギフト（dポイント）の紛失、盗難、破損、IDの漏洩等の責任は負いません。
      　・ポイント＠ギフト（dポイント）の登録サイトは、日本国外からのアクセスはできません。
      　・その他注意事項は「利用規約」（ https://atgift.jp/user/item/dpoint/use-rule/ ）をご確認ください。

      ●ポイント＠ギフト（dポイント）に関するお問い合わせ（株式会社NTTカードソリューション）
      ポイント＠ギフト（dポイント）に関してのよくあるご質問（登録方法など）は、下記のURLをご覧ください。
      　https://atgift.jp/user/c-faq/dpoint/　
      　※お問い合わせの際は「管理番号」をお知らせください。`;

    this.description = description.replace(/^ +/gm, "");

    this.message = '※「ポイント＠ギフト」は、株式会社NTTカードソリューションが発行する電子マネーギフトサービスです。'
});